export const MAIL_SPLIT_LAYOUT_KEY = "mail-split-layout-v1";

export type MailSplitLayout = {
  navWidth: number;
  listWidth: number;
};

export const MAIL_SPLIT_DEFAULTS: MailSplitLayout = {
  navWidth: 220,
  listWidth: 380,
};

export const MAIL_SPLIT_MIN_NAV = 168;
export const MAIL_SPLIT_MAX_NAV = 360;
export const MAIL_SPLIT_MIN_LIST = 260;
export const MAIL_SPLIT_MAX_LIST = 640;
/** Largeur liste temporaire quand la lecture est élargie à la main (non persistée). */
export const MAIL_SPLIT_PREVIEW_LIST = 220;
export const MAIL_SPLIT_MIN_READING = 280;
export const MAIL_SPLIT_RESIZER_PX = 10;

function clamp(n: number, min: number, max: number) {
  return Math.min(max, Math.max(min, n));
}

export function readMailSplitLayout(): MailSplitLayout {
  try {
    const raw = localStorage.getItem(MAIL_SPLIT_LAYOUT_KEY);
    if (!raw) return { ...MAIL_SPLIT_DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<MailSplitLayout>;
    return {
      navWidth: clamp(Number(parsed.navWidth) || MAIL_SPLIT_DEFAULTS.navWidth, MAIL_SPLIT_MIN_NAV, MAIL_SPLIT_MAX_NAV),
      listWidth: clamp(Number(parsed.listWidth) || MAIL_SPLIT_DEFAULTS.listWidth, MAIL_SPLIT_MIN_LIST, MAIL_SPLIT_MAX_LIST),
    };
  } catch {
    return { ...MAIL_SPLIT_DEFAULTS };
  }
}

export function persistMailSplitLayout(layout: MailSplitLayout) {
  try {
    localStorage.setItem(MAIL_SPLIT_LAYOUT_KEY, JSON.stringify(layout));
  } catch {
    /* ignore */
  }
}
